type KnownErrorResponse = {
  code: ApiError;
  message: string;
  data: unknown;
  known: true;
};

type UnknownErrorResponse = {
  message: string;
  data: unknown;
  known: false;
};

export function isKnownErrorResponse(
  error: unknown,
): error is KnownErrorResponse {
  return (
    typeof error === 'object' &&
    error !== null &&
    'known' in error &&
    error.known === true
  );
}

export function isUnknownErrorResponse(
  error: unknown,
): error is UnknownErrorResponse {
  return (
    typeof error === 'object' &&
    error !== null &&
    'known' in error &&
    error.known === false
  );
}

export type ErrorResponse = KnownErrorResponse | UnknownErrorResponse;

export function isKnownAPIError(error: unknown): error is ErrorResponse {
  return typeof error === 'object' && error !== null && 'known' in error;
}

export const API_ERRORS = {
  OK: 'OK',
  BAD_REQUEST: 'BAD_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  INVALID_ACCESS_TOKEN: 'INVALID_ACCESS_TOKEN',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type ApiError = (typeof API_ERRORS)[keyof typeof API_ERRORS];

export const STATUS_CODES: Record<ApiError, number> = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  INVALID_ACCESS_TOKEN: 401,
  UNAVAILABLE: 503,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_ERROR: 500,
};
